import React from 'react';
import MultiAutoCompleteFilter from 'components/list/Filters/types/MultiAutoCompleteFilter';
import rolesHelper from 'helpers/roles';

const MultiResellerIdFilter = <MultiAutoCompleteFilter
    label='filters.components.resellerId.label'
    options={ {
        fullWidth: true,
    } }
    searchParams={ {
        role_id: [
            rolesHelper.getResellerRoleId(),
        ],
        size: '12',
        sort_by: 'name',
        sort_direction: 'asc',
    } }
    reference='accounts'
    optionValue='id'
    searchBy='name'
    source='reseller_id'
/>;

export default MultiResellerIdFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/MultiResellerIdFilter.js